import React from 'react';
import {
  GetBrandClassificationMetricsResponse,
  useBrandClassificationSplineMetrics
} from './hooks/useBrandClassificationMetrics';
import TotalTrafficDonutChart from './TotalTrafficDonutChart';
import { TrafficBarCharts } from './TrafficBarCharts';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { useAppSelector } from 'src/utils/Hooks';

function getTrafficTypeTotal(
  response: GetBrandClassificationMetricsResponse,
  key: 'organicTraffic' | 'totalTraffic' | 'paidTraffic'
) {
  return response.records.reduce((acc, record) => {
    return acc + record[key];
  }, 0);
}

/**
 * Donut and bar charts for topics views
 */
export function TotalTrafficTopSectionForTopics() {
  const { startWeek, endWeek } = useAppSelector((state) => state.mainTimePeriod);
  const { startWeek: comparisonStartWeek, endWeek: comparisonEndWeek } = useAppSelector(
    (state) => state.comparisonTimePeriod
  );
  const { response, isLoading } = useBrandClassificationSplineMetrics({
    buildRequest: (baseRequest, isComparison) => {
      return isComparison
        ? baseRequest.setStartWeekId(comparisonStartWeek).setEndWeekId(comparisonEndWeek)
        : baseRequest.setStartWeekId(startWeek).setEndWeekId(endWeek);
    }
  });

  const organicClicks = getTrafficTypeTotal(response[0], 'organicTraffic');
  const paidClicks = getTrafficTypeTotal(response[0], 'paidTraffic');
  const totalClicks = getTrafficTypeTotal(response[0], 'totalTraffic');

  const organicClicksComparison = getTrafficTypeTotal(response[1], 'organicTraffic');
  const paidClicksComparison = getTrafficTypeTotal(response[1], 'paidTraffic');

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <TotalTrafficDonutChart
        loading={isLoading}
        dspClicks={0}
        organicClicks={organicClicks}
        otherTraffic={0}
        paidTraffic={paidClicks}
        totalClicks={totalClicks}
      />
      <TrafficBarCharts
        loading={isLoading}
        organicTraffic={{
          current: organicClicks,
          comparison: organicClicksComparison
        }}
        paidTraffic={{
          current: paidClicks,
          comparison: paidClicksComparison
        }}
        otherTraffic={{
          current: 0,
          comparison: 0
        }}
      />
    </Flex>
  );
}
